function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS Popover INSTEAD.
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, noop } from 'lodash';
import * as ReactStrap from 'reactstrap';
import classNames from 'classnames';
var Popover = /*#__PURE__*/function (_Component) {
  function Popover(props) {
    var _this;
    _classCallCheck(this, Popover);
    _this = _callSuper(this, Popover, [props]);
    _this.state = {
      done: false
    };
    return _this;
  }
  _inherits(Popover, _Component);
  return _createClass(Popover, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        id = _this$props.id,
        hideArrow = _this$props.hideArrow,
        className = _this$props.className,
        isOpen = _this$props.isOpen,
        target = _this$props.target,
        placement = _this$props.placement,
        toggle = _this$props.toggle,
        header = _this$props.header,
        body = _this$props.body,
        boundariesElement = _this$props.boundariesElement;
      var popoverClass = function popoverClass() {
        return classNames({
          'ui-popover': true,
          'ui-popover--no-arrow': hideArrow
        }, className);
      };
      return /*#__PURE__*/React.createElement(ReactStrap.Popover, {
        id: id,
        className: popoverClass(),
        toggle: toggle,
        isOpen: isOpen,
        target: target,
        placement: placement,
        hideArrow: hideArrow,
        trigger: "legacy",
        fade: false,
        boundariesElement: boundariesElement
      }, !isEmpty(header) ? /*#__PURE__*/React.createElement(ReactStrap.PopoverHeader, null, header) : null, !isEmpty(body) ? /*#__PURE__*/React.createElement(ReactStrap.PopoverBody, null, body) : null);
    }
  }]);
}(Component);
Popover.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** prop to determine open and close state of popover */
  isOpen: PropTypes.bool,
  /** id of target anchor */
  target: PropTypes.node.isRequired,
  /** toggle function necessary for switching between open and close state */
  toggle: PropTypes.func,
  /** placement of popover */
  placement: PropTypes.oneOf(['auto', 'auto-start', 'auto-end', 'top', 'top-start', 'top-end', 'right', 'right-start', 'right-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end']),
  /** Header data */
  header: PropTypes.string,
  /** hide or show arrow */
  hideArrow: PropTypes.bool,
  /** Body data */
  body: PropTypes.node,
  /** Boundaries for popper, can be scrollParent, window, viewport, or any DOM element */
  boundariesElement: PropTypes.string
};
Popover.defaultProps = {
  id: '',
  className: '',
  isOpen: false,
  target: '',
  placement: 'auto',
  toggle: noop,
  header: '',
  body: [],
  hideArrow: false,
  boundariesElement: ''
};
export default Popover;